<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_pwd my_style">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <div class="current_title">个人设置</div>
        <div class="left_content">
          <div class="link_item" @click="$router.push('/user-center-info')">
            个人设置
          </div>
          <div class="link_item link_item_active">
            修改密码
          </div>
        </div>
        <div class="right_content">
          <p class="head_title">修改密码</p>
          <div class="edit_pwd">
            <div class="item">
              <span class="head">原密码：</span>
              <input type="password" v-model="pwd.old_password" />
            </div>
            <div class="item">
              <span class="head">新密码：</span>
              <input type="password" v-model="pwd.password" />
            </div>
            <div class="item">
              <span class="head">确认密码：</span>
              <input type="password" v-model="pwd.password_confirmation" />
            </div>
          </div>
          <button class="save hand_point" @click="reset">保存</button>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottom">
      <div class="content pr">
        <span class="gift">
          <img src="../../assets/image/user_center/icon (1).png" alt class="pic_full" />
        </span>
        <span class="free_info">
          每成功推荐一个朋友学习，满足奖励条件后即可获得
          <span class="red">200元充值</span>，奖励可累积哦！
        </span>
        <div class="qr_code">
          <div class="qrcode_img">
            <canvas id="QRCode"></canvas>
          </div>
          <p class="notice_info">
            <span class="wechat_icon">
              <img src="../../assets/image/user_center/icon (2).png" alt class="pic_full" />
            </span>
            <span>扫码分享到微信</span>
          </p>
        </div>
        <button class="call_btn hand_point">查看奖励</button>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import UserLeftMenu from "../common/user_left_menu.vue";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    UserLeftMenu
  },
  data: function() {
    return {
      pwd: {
        old_password: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  mounted: function() {
    this.get_share_code();
  },
  methods: {
    reset() {
      let self = this;
      let { old_password, password, password_confirmation } = this.pwd;
      common.requestFun(
        self,
        "post",
        "/student/password/reset",
        {
          old_password: old_password,
          password: password,
          password_confirmation: password_confirmation
        },
        res => {
          if (res.data.code == 200) {
            self.$message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });
          } else {
                if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    get_share_code() {
      //生成分享二维码
      let self = this;
      common.requestFun(self, "get", "/student/recommend_code", {}, res => {
        if (res.data.code == 200) {
          var msg = document.getElementById("QRCode");
          QRCode.toCanvas(
            msg,
            `http://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,
            function(error) {
              console.log(error);
            }
          );
        }
      });
    }
  }
};
</script>
<style scoped src="./user_center_pwd.css"></style>